$(document).ready(function() {
	if ($("total-price-vat").length === 0) {
		return;
	}

	let timestampNow = Date.now();
	let timestampPriceValidTo = parseInt($("total-price-vat").data("timestamp-price-valid-to")) * 1000;
	let interval = timestampPriceValidTo - timestampNow + 1000;

	if (interval > 0) {
		setTimeout(() => {location.reload()}, interval);
	}
	else {
		setTimeout(() => {location.reload()}, 60 * 1000);
	}
});
